
import React, { createContext, useContext, useState } from 'react';

interface QualificationFormDialogContextType {
  isOpen: boolean;
  openFormDialog: () => void;
  closeFormDialog: () => void;
}

const QualificationFormDialogContext = createContext<QualificationFormDialogContextType | undefined>(undefined);

export const QualificationFormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openFormDialog = () => {
    setIsOpen(true);
  };

  const closeFormDialog = () => {
    setIsOpen(false);
  };

  return (
    <QualificationFormDialogContext.Provider
      value={{ isOpen, openFormDialog, closeFormDialog }}
    >
      {children}
    </QualificationFormDialogContext.Provider>
  );
};

export function useQualificationFormDialog() {
  const context = useContext(QualificationFormDialogContext);
  if (!context) {
    throw new Error('useQualificationFormDialog must be used within a QualificationFormProvider');
  }
  return context;
}
